import { render, staticRenderFns } from "./ObligationManager.vue?vue&type=template&id=bb9a4400&"
import script from "./ObligationManager.vue?vue&type=script&lang=js&"
export * from "./ObligationManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports